const data = {
    1: {
        question: 'Как назовёшь компанию?',
        answers: [
            {
                text: 'Назовусь «СМАК» — Самая Модная Аутсорсинговая Компания. Или это где-то было уже?',
                reaction: {
                    money: null,
                    mood: -1,
                    rating: 2
                },
                goto: 2
            },
            {
                text: 'Найму агентство, которое придумает название и сделает брендинг. Подход должен быть основательным.',
                reaction: {
                    money: -1,
                    mood: 1,
                    rating: -1
                },
                goto: 2
            }
        ]
    },
    2: {
        question: 'Какое направление возьмёшь за основу?',
        answers: [
            {
                text: 'Расчёт заработной платы и кадровое делопроизводство.',
                reaction: {
                    money: null,
                    mood: -1,
                    rating: 2
                },
                goto: 3.1
            },
            {
                text: 'Бухгалтерский и налоговый учёт.',
                reaction: {
                    money: -1,
                    mood: 1,
                    rating: -2
                },
                goto: 3.2
            }
        ]
    },
    3.1: {
        question: 'А вот и первый клиент —  крупная компания с громким именем. Тебе повезло! Такой контракт привлечёт новых клиентов и укрепит твою позицию на рынке. В курилке их офиса твой юрист случайно услышал, что все зарплаты сотрудников — «белые», а вот премии руководство выплачивает в конвертах.<br>Будешь заключать договор с таким клиентом?',
        answers: [
            {
                text: 'Мы работаем только в рамках правового поля. Риск для аутсорсера — дело неблагородное.',
                reaction: {
                    money: null,
                    mood: 1,
                    rating: -2
                },
                goto: 4
            },
            {
                text: 'Мы работаем только с фактами хозяйственной деятельности, все риски — на клиенте. Сделаю вид, что не знаю про деньги в конвертах, это нас не касается.',
                reaction: {
                    money: 3,
                    mood: -2,
                    rating: +8
                },
                goto: 4
            }
        ]
    },
    3.2: {
        question: 'А вот и первый  клиент — международная компания, работающая на территории России. Западные офисы используют учётные системы, локализация которых трудна и дорога для России. Поэтому клиент ведёт двойной учёт: привычный и понятный 1С — для своих задач и глобальная HR-система — для международных. Это неудобно и трудозатратно.<br>Как будешь решать проблему?',
        answers: [
            {
                text: 'Напомню зарубежным коллегам о 152-ФЗ «О персональных данных», согласно которому первоначальный сбор и хранение данных должны осуществляться на территории РФ, и попрошу их не создавать проблем нашему клиенту. Пусть переходят на 1С!',
                reaction: {
                    money: -15,
                    rating: -2,
                    rating: 3
                },
                goto: '4-adv'
            },
            {
                text: 'Предложу интегрировать 1С с глобальными системами, где ведущей системой будет 1С, а ведомой — корпоративная система зарубежных офисов. Как тебе такое, Илон Маск?',
                reaction: {
                    money: 7,
                    rating: +1,
                    rating: -2
                },
                goto: '4-adv'
            }
        ]
    },
    '4-adv': {
        isAdv: true,
        advText: 'Минутка рекламной паузы.<br>UCMS Group Russia интегрирует платформу 1С с любыми программными продуктами с различным уровнем автоматизации. Интеграция может быть как односторонней, так и двунаправленной, а ведущая система — как глобальной, так и 1С.<br>На WorkDay  надейся, а мы с интеграцией не оплошаем.',
        answers:[{
            goto: 4
        }]
    },
    4: {
        question: 'Количество контрактов растёт, и в штате появилось место для ещё одного руководителя проектов.<br>Какого сотрудника возьмёшь?',
        answers:[
            {
                text: 'Переманю крутого руководителя проектов из конкурирующей компании и предложу ЗП в два раза выше рыночной.',
                reaction: {
                    money: -10,
                    mood: -1,
                    rating: -1
                },
                logicGoto: {
                    '3.1_1': 5.1,
                    '3.1_2': 5.2,
                    '3.2_1': 5.3,
                    '3.2_2': 5.4
                }
            },
            {
                text: 'Бывшего одноклассника Вову. Да, опыта маловато, зато человек надёжный и ответственный.',
                reaction: {
                    money: -1,
                    mood: -1,
                    rating: null
                },
                logicGoto: {
                    '3.1_1': 5.1,
                    '3.1_2': 5.2,
                    '3.2_1': 5.3,
                    '3.2_2': 5.4
                }
            }
        ]
    },
    5.1: {
        question: 'Кто-то сдал компанию, с которой ты отказался сотрудничать, налоговой и трудовой инспекциям, Пенсионному фонду и бабушке Любе на лавочке. Теперь они все недовольны, и по поводу премий в конвертах ведётся проверка. Хорошо, что ты в этом не замешан!<br>Пора искать новые проекты и подключать рекламу. Какую выберешь?',
        answers:[
            {
                text: 'Заведу аккаунт в ТикТок. Хочу идти в ногу со временем. Йоу!',
                reaction: {
                    money: -2,
                    mood: 2,
                    rating: -3
                },
                goto: 6
            },
            {
                text: 'Куплю рекламу в газете. Серьёзные люди, у которых есть деньги, их читают.',
                reaction: {
                    money: -4,
                    mood: null,
                    rating: -2
                },
                goto: 6
            }
        ]
    },
    5.2: {
        question: 'Кто-то сдал твоего клиента налоговой и трудовой инспекциям, Пенсионному фонду и бабушке Любе на лавочке. Теперь они все недовольны, и по поводу премий в конвертах ведётся проверка. Она изрядно потрепала тебе и твоим сотрудникам нервы, но вам удалось доказать свою непричастность к этому.<br>Пора искать новых законопослушных клиентов и подключать рекламу. Какую выберешь?',
        answers:[
            {
                text: 'Заведу аккаунт в ТикТок. Хочу идти в ногу со временем. Йоу!',
                reaction: {
                    money: -2,
                    mood: 2,
                    rating: -3
                },
                goto: 6
            },
            {
                text: 'Куплю рекламу в газете. Серьёзные люди, у которых есть деньги, их читают.',
                reaction: {
                    money: -4,
                    mood: null,
                    rating: -2
                },
                goto: 6
            }
        ]
    },
    5.3: {
        question: 'Международная компания, с которой ты сотрудничал, ушла к твоим конкурентам из-за услуги «Интеграция 1С с глобальными системами», и ты потерял 5% прибыли.<br>Пора искать новые проекты и подключать рекламу. Какую выберешь?',
        answers:[
            {
                text: 'Заведу аккаунт в ТикТок. Хочу идти в ногу со временем. Йоу!',
                reaction: {
                    money: -1,
                    mood: 2,
                    rating: -3
                },
                goto: 6
            },
            {
                text: 'Куплю рекламу в газете. Серьёзные люди, у которых есть деньги, их читают.',
                reaction: {
                    money: -4,
                    mood: null,
                    rating: -2
                },
                goto: 6
            }
        ]
    },
    5.4: {
        question: 'Международная компания, которой ты предложил интегрировать 1С с глобальными системами, довольна решением и рассказала о тебе своим партнёрам. Плюс три новых клиента! Проекты крутятся, деньжата мутятся.<br>Дашь компании скидку в благодарность за отзывы?',
        answers:[
            {
                text: 'Конечно! Лучшая реклама — отзывы клиентов.',
                reaction: {
                    money: -10,
                    mood: null,
                    rating: -2    
                },
                goto: 6
            },
            {
                text: 'Ну уж нет. Лучшая реклама — бесплатная реклама.',
                reaction: {
                    money: 2,
                    mood: 1,
                    rating: 3    
                },
                goto: 6
            }
        ]
    },
    6: {
        question: 'Менеджеру по продажам в 8 вечера позвонил клиент и попросил переделать договор к завтрашнему утру.<br>Менеджер спрашивает у тебя: садиться за работу сейчас или отложить на завтра?',
        answers:[
            {
                text: 'Крепостное право отменили в 1861. Скажу, что рабочие дела решаются только в рабочие часы, и отправлю менеджера спать.',
                reaction: {
                    money: -6,
                    mood: 2,
                    rating: 1    
                },
                goto: 7
            },
            {
                text: 'Попрошу менеджера решить вопрос незамедлительно. Задачи клиентов — наш приоритет.',
                reaction: {
                    money: 4,
                    mood: -2,
                    rating: -3   
                },
                goto: 7
            }
        ]
    },
    7: {
        question: 'Помимо основного контракта, твоя компания подписала SLA (Service Level Agreement) — соглашение об уровне предоставления услуг. Согласно этим документам аутсорсер несёт ответственность не только за реальный ущерб клиенту, но и за нарушения процедуры. Сотрудник неверно посчитал ЗП и предоставил расчёты с задержкой. Теперь компания должна выплатить реальный ущерб и штраф клиенту по SLA.<br>Вычтешь из ЗП сотрудника?',
        answers:[
            {
                text: 'Мы в ответе за тех, кого обсчитали! Вычту и лишу премии.',
                reaction: {
                    money: null,
                    mood: -2,
                    rating: 3    
                },
                goto: 8
            },
            {
                text: 'Кто не ошибается, тот просто ничего не делает. Разработаем чек-листы проверок, чтобы таких ошибок больше не было, и оформим профессиональную страховку. А пока заплатим штраф из бюджета компании.',
                reaction: {
                    money: -10,
                    mood: 2,
                    rating: -4   
                },
                goto: 8
            }
        ]
    },
    8: {
        question: 'Твой постоянный клиент решает уйти к конкуренту из-за роста цен на услуги и просит передать новой аутсорсинговой компании базу данных, реестры и всю первичную документацию.<br>Отдашь все свои наработки по этому проекту конкурирующей компании или бросишь бывшего клиента на произвол судьбы?',
        answers:[
            {
                text: 'Как говорил Сократ: «Расставашки — всегда печалька». Поэтому пусть разбираются сами. Ещё прибегут к нам обратно!',
                reaction: {
                    money: null,
                    mood: -1,
                    rating: 6   
                },
                goto: '9-adv'
            },
            {
                text: 'С нами легко заключить договор и так же легко прекратить сотрудничество. Поступим как джентльмены. Мы же лэйди.',
                reaction: {
                    money: null,
                    mood: 2,
                    rating: -1
                },
                goto: '9-adv'
            }
        ]
    },
    '9-adv': {
        isAdv: true,
        advText: 'Если бы мы наняли блогера рекламировать наши услуги, он бы сказал: «Мои подписчики часто спрашивают, в какую аутсорсинговую компанию я обращаюсь. Так вот...». Но это было бы неправдой, а мы делаем рекламу честно. И выходим из контракта тоже.<br>Во время этой рекламы ни один блогер не пострадал.',
        answers:[{
            logicGoto: {
                '8_1': 9.1,
                '8_2': 9.2,
            }
        }]
    },
    9.1: {
        question: 'Твой бывший клиент рассказал, каких трудов стоило выйти из контракта с тобой, и теперь никто из его отрасли не хочет вести сотрудничество с аутсорсером-диктатором. Придётся потрудиться, чтобы вернуть репутацию.<br>Тем временем твой клиент — FMCG компания, которой ты оказываешь услуги по расчёту ЗП, хочет уволить сотрудника. Ты видишь, что это решение идёт вразрез с Трудовым кодексом РФ.<br>Твоя компания вмешается?',
        answers:[
            {
                text: 'Сделаем консультацию по трудовому праву и найдём решение, которое обезопасит клиента от рисков трудовых споров. С клиентом хоть в разведку, хоть в суд.',
                reaction: {
                    money: 10,
                    mood: 2,
                    rating: -1
                },
                goto: '10-adv'
            },
            {
                text: 'Хах, нет. Инициатива наказуема, и если уволенный сотрудник подаст в суд, это отразится на нас. Просто примем факт увольнения. Это не наша компетенция.',
                reaction: {
                    money: -21,
                    mood: -1,
                    rating: 6
                },
                goto: '10-adv'
            }
        ]
    },
    9.2: {
        question: 'Твой бывший клиент был приятно удивлён и поблагодарил тебя за сотрудничество. И даже упомянул название твоей компании на конференции, поэтому парочка новых клиентов из его отрасли у тебя в кармане.<br>Тем временем твой клиент — FMCG компания, которой ты оказываешь услуги по расчёту ЗП — хочет уволить сотрудника. Ты видишь, что это решение идёт вразрез с Трудовым кодексом РФ.<br>Твоя компания вмешается?',
        answers:[
            {
                text: 'Сделаем консультацию по трудовому праву и найдём решение, которое обезопасит клиента от рисков трудовых споров. С клиентом хоть в разведку, хоть в суд.',
                reaction: {
                    money: 10,
                    mood: 2,
                    rating: -1
                },
                goto: '10-adv'
            },
            {
                text: 'Хах, нет. Инициатива наказуема, и если уволенный сотрудник подаст в суд, это отразится на нас. Просто примем факт увольнения. Это не наша компетенция.',
                reaction: {
                    money: -21,
                    mood: -1,
                    rating: 6   
                },
                goto: '10-adv'
            }
        ]
    },
    '10-adv': {
        isAdv: true,
        advText: '«Всегда предупреждать о рисках и говорить о возможностях» — кредо не только инструкторов по парашютному спорту, но и компании UCMS Group. Даже если мы оказываем клиенту только одну услугу, но видим, где клиент рискует деньгами, временем или репутацией, а где, наоборот, не использует все возможности, мы ему об этом скажем.',
        answers:[{
            logicGoto: {
                '9.1_1': 10.1,
                '9.2_1': 10.1,
                '9.1_2': 10.2,
                '9.2_2': 10.2
            }
        }]
    },
    10.1: {
        question: 'Уволенный сотрудник подал в суд, но твой юрист выиграл дело. Теперь к услуге по подготовке расчёта ЗП прибавились консультации по трудовому праву, кадровая проверка, охрана труда и аудит бизнес-процессов. А к сумме в вашем договоре — нолик.<br>Как отметишь удачную сделку?',
        answers: [
            {
                text: 'Устрою корпоратив на природе. Тимбилдинг — дело тонкое.',
                reaction: {
                    money: -2,
                    mood: 1,
                    rating: -1 
                },
                goto: 11
            },
            {
                text: 'Выпишу премию всему отделу. Гулять так гулять!',
                reaction: {
                    money: -5,
                    mood: 4,
                    rating: null 
                },
                goto: 11
            }
        ]
    },
    10.2: {
        question: 'Уволенный сотрудник подал в суд, и твой клиент проиграл. Сумма компенсации немаленькая, и он не сможет оплачивать полную стоимость  услуг твоей компании.<br>Сделаешь скидку или найдёшь нового клиента?',
        answers:[
            {
                text: 'Постоянный клиент — почти как родственник. А родственники должны помогать друг другу!',
                reaction: {
                    money: -9,
                    mood: -1,
                    rating: -1
                },
                goto: 11
            },
            {
                text: 'Работать себе в убыток — сомнительное удовольствие. Расторгну договор.',
                reaction: {
                    money: 4,
                    mood: null,
                    rating: null  
                },
                goto: 11
            }
        ]
    },
    11: {
        question: 'Система менеджмента качества (СМК) — набор инструментов, который позволяет контролировать процессы, управлять рисками и постоянно повышать качество через улучшение процессов. Аудит СМК нужно проходить раз в год, и это недёшево. А ещё в штат нужно нанять специальных сотрудников, которые будут следить за соблюдением СМК.<br>Клиенты доверяют компании и без СМК, а твой заместитель уверяет, что всё и так в порядке, а СМК ни к чему. Будешь внедрять СМК и регулярно проходить аудиты?',
        answers:[
            {
                text: 'Доверяю своему заму и мнению клиентов, а всякие процедуры, инструкции и бумажки с печатями — пустая трата денег, нервов и сил.',
                reaction: {
                    money: null,
                    mood: null,
                    rating: 6   
                },
                logicGoto: {
                    '4_1': 12.1,
                    '4_2': 12.2,
                }
            },
            {
                text: 'Верю в волшебную силу СМК, поэтому я в деле!',
                reaction: {
                    money: -5,
                    mood: 2,
                    rating: -2
                },
                logicGoto: {
                    '4_1': 12.1,
                    '4_2': 12.2
                }
            }
        ]
    },
    12.1: {
        question: 'Крутого руководителя проекта, которого ты в самом начале переманил из конкурирующей компании, переманила другая компания в самый ответственный момент. Теперь тебе срочно нужно искать нового руководителя проектов!<br>Где на этот раз?',
        answers:[
            {
                text: 'Пусть HR-менеджер найдёт кого-то подходящего на эту роль внутри компании. У нас что толковых руководителей проектов нет?',
                reaction: {
                    money: null,
                    mood: 2,
                    rating: null   
                },
                goto: 13
            },
            {
                text: 'Поручу HR-менеджеру прошерстить все сайты по поиску сотрудника и устроить кандидатам проверку на детекторе лжи.',
                reaction: {
                    money: -3,
                    mood: null,
                    rating: null     
                },
                goto: 13
            }
        ]
    },
    12.2: {
        question: 'Одноклассник Вова, которого ты взял на работу в самом начале, оставил всю свою ответственность на контрольной работе по алгебре в 10 классе. Поэтому вместо встречи с клиентом поехал на шашлыки. Теперь тебе нужно восстанавливать отношения с клиентом и искать нового руководителя проектов!<br>Где на этот раз?',
        answers:[
            {
                text: 'Пусть HR-менеджер найдёт кого-то подходящего на эту роль внутри компании. У нас что, толковых руководителей проектов нет?',
                reaction: {
                    money: null,
                    mood: 2,
                    rating: null     
                },
                goto: 13
            },
            {
                text: 'Поручу HR-менеджеру прошерстить все сайты по поиску сотрудника и устроить кандидатам проверку на детекторе лжи.',
                reaction: {
                    money: -3,
                    mood: null,
                    rating: null     
                },
                goto: 13
            }
        ]
    },
    13: {
        question: 'Команда предлагает внедрить новую услугу — «Личный кабинет сотрудника». Он поможет автоматизировать ненавистную бюрократию и оперативно собирать всю информацию о сотрудниках в одном месте.<br>Стоимость — половина годовой прибыли компании. Что скажешь?',
        answers:[
            {
                text: 'Мы не можем так рисковать. А если не зайдёт, кто ЗП сотрудникам будет выплачивать? Давайте без новомодных услуг.',
                reaction: {
                    money: null,
                    mood: -2,
                    rating: 5     
                },
                goto: '14-adv'
            },
            {
                text: 'Ставлю пирожки своей бабушки на то, что дело выгорит. Запускаем!',
                reaction: {
                    money: -10,
                    mood: 2,
                    rating: -3
                },
                goto: '14-adv'
            }
        ]
    },
    '14-adv': {
        isAdv: true,
        advText: 'Вспомните, когда вы последний раз ходили в банк, чтобы оплатить услуги? А когда сами забирали еду из ресторана вместо доставки? Или вызывали такси через диспетчера? Всё это вытеснили приложения с личными кабинетами. Так может быть, пора использовать личный кабинет на работе?<br>Обратитесь к нам, когда решитесь получить цифровое преимущество для компании. EmployeeGate — интегрированное портальное решение для сотрудников от UCMS Group Russia.',
        answers:[{
            goto: 14
        }]
    },
    14: {
        question: 'Компания-работодатель обязана уведомлять военкоматы о передвижениях военнообязанных сотрудников. Разумеется, работодателю некогда это делать, поэтому ты предлагаешь им услугу «Воинский учёт».<br>Какой рекламный слоган возьмёшь?',
        answers:[
            {
                text: 'Креативный: «Воинский учёт» — нас не догонят!',
                reaction: {
                    money: null,
                    mood: 2,
                    rating: null   
                },
                goto: '15-adv'
            },
            {
                text: 'Коротко и по делу: «Воинский учёт» — никаких повесток, только спокойствие.',
                reaction: {
                    money: null,
                    mood: 2,
                    rating: null   
                },
                goto: '15-adv'
            }
        ]
    },
    '15-adv': {
        isAdv: true,
        advText: 'У нас есть описание услуги «Воинский учёт» на две страницы. А ещё у нас есть уверенность, что все работодатели, кто хоть раз сталкивался с повестками, бумажной волокитой и учётом в авральном режиме, понимают ценность услуги и без описания.',
        answers:[{
            logicGoto: {
                '11_1': 15.1,
                '11_2': 15.2
            }
        }]
    },
    15.1: {
        question: 'Помнишь тот  СМК, на который ты поскупился? В итоге твои спецы не заметили ошибку в процессах, и компания потеряла намного больше.<br>Как будешь восстанавливать бюджет?',
        answers:[
            {
                text: 'Сокращу часть сотрудников, иначе до конца года мы не протянем.',
                reaction: {
                    money: 5,
                    mood: -4,
                    rating: 1     
                },
                goto: 16
            },
            {
                text: 'Скажу сотрудникам, что сейчас в компании непростые времена и придётся перерабатывать, так как нужно брать больше проектов. Зато останемся в полном составе.',
                reaction: {
                    money: -10,
                    mood: -4,
                    rating: 1     
                },
                goto: 16
            }
        ]
    },
    15.2: {
        question: 'СМК помог выявить ошибку в процессах и сэкономил твоей компании кучу денег. И нервов. И времени. Так держать!<br>А что насчёт корпоратива? Потратишься на него с такой же лёгкостью или отметишь скромно?',
        answers:[
            {
                text: 'Год выдался тяжёлым: только инопланетяне на Землю не прилетали. Поэтому потрачусь, не задумываясь.',
                reaction: {
                    money: -8,
                    mood: 4,
                    rating: null     
                },
                goto: 16
            },
            {
                text: 'Приберегу эти деньги для подушки безопасности. А то мало ли что. А салатики можем и в офисе поесть, даже уютнее будет.',
                reaction: {
                    money: null,
                    mood: -4,
                    rating: null     
                },
                goto: 16
            }
        ]
    },
    16: {
        question: 'И последний самый важный выбор. Кого позовёшь на корпоратив?',
        answers:[
            {
                text: 'Меладзе',
                reaction: null,
                goto: 'finish'
            },
            {
                text: 'Меладзе!!!',
                reaction: null,
                goto: 'finish'
            },
        ]
    }
}

export default data